
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderProductReportGrid extends Serenity.EntityGrid<OrderProductsRow, any> {
        protected getColumnsKey() { return OrderProductReportColumns.columnsKey; }
        protected getDialogType() { return OrderProductsDialog; }
        protected getIdProperty() { return OrderProductsRow.idProperty; }
        protected getInsertPermission() { return OrderProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProductsRow.localTextPrefix; }
        protected getService() { return OrderProductsService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export Selected to Excel',
                service: OrderProductsService.baseUrl + '/ListExcelSelected',
                onViewSubmit: () => {
                    var selectedKeys = this.rowSelection.getSelectedKeys();
                    if (selectedKeys.length === 0) {
                        Q.notifyWarning('Please select at least one record to export');
                        return false;
                    }
                    if (!this.onViewSubmit()) {
                        return false;
                    }
                    // Add criteria to filter by selected IDs
                    var request = this.view.params as Serenity.ListRequest;
                    request.Criteria = Serenity.Criteria.and(
                        request.Criteria,
                        [['Id'], 'in', [selectedKeys]]
                    );
                    return true;
                },
                separator: true
            }));
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderProductsService.baseUrl + '/ListExcel2',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}